'use client';

import classNames from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import Typography from '@alltrails/core/components/Typography';
import Accordion from '@alltrails/denali/components/Accordion';
import styles from './SidebarAccordion.module.scss';

type SidebarAccordionProps = Omit<ComponentProps<typeof Accordion>, 'title'> & {
  title: ReactNode;
  bodyClassName?: string;
  noBodyPadding?: boolean;
};

const SidebarAccordion = ({
  title,
  children,
  bodyClassName,
  noBodyPadding = false,
  initiallyOpen = true,
  borderBottomContainerClassName,
  buttonContainerClassName,
  ...rest
}: SidebarAccordionProps) => (
  <Accordion
    {...rest}
    initiallyOpen={initiallyOpen}
    title={<Typography variant="heading300">{title}</Typography>}
    borderBottomContainerClassName={classNames(styles.borderBottom, borderBottomContainerClassName)}
    buttonContainerClassName={classNames(styles.buttonContainer, buttonContainerClassName)}
  >
    {noBodyPadding ? children : <div className={classNames(styles.body, bodyClassName)}>{children}</div>}
  </Accordion>
);

export default SidebarAccordion;
